'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Icon = _interopDefault(require('@narvar/nth-bit-icon-button'));
var Close = _interopDefault(require('@narvar/nth-close'));

var Dismiss = function Dismiss(_ref) {
  var s = _ref.s,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Icon, {
    onClick: onClick,
    ariaLabel: "close"
  }, /*#__PURE__*/React.createElement(Close, {
    s: s
  }));
};
Dismiss.defaultProps = {
  s: {},
  onClick: undefined
};
Dismiss.propTypes = {
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
    verticalAlign: PropTypes.string
  }),
  onClick: PropTypes.func
};

exports.default = Dismiss;
